// @flow
import {
  DateTime,
  Interval,
} from 'luxon';

import type {
  IntervalType,
  DatePickerMode,
} from 'chronos-types';

export function getDateLabel(date: IntervalType) {
  return date.length === 1
    ? `${date.start.toFormat(DateTime.DATE_FULL)}`
    : `${date.start.toFormat(DateTime.DATE_FULL)}\
 - ${date.end.toFormat(DateTime.DATE_FULL)}`;
}

export function getPopupDateLabel(date: IntervalType, mode: DatePickerMode) {
  switch (mode) {
    case 'Month':
      return date.end.toFormat('MMMM yyyy');
    case 'Week':
      return date.end.toFormat('WW \'week of\' yyyy');
    case 'Day':
      return date.end.toLocaleString(DateTime.DATE_HUGE);
    case 'Custom':
      return 'Custom';
    default:
      return 'Invalid date';
  }
}

export function jumpToDate(mode: DatePickerMode, dir: string, date: IntervalType) {
  const ofOption = mode.toLowerCase();
  if (mode === 'Day') {
    switch (dir) {
      case 'Prev': {
        return date.set({
          start: date.start.minus({ days: 1 }),
          end: date.end.minus({ days: 1 }),
        });
      }
      case 'Next': {
        return date.set({
          start: date.start.plus({ days: 1 }),
          end: date.end.plus({ days: 1 }),
        });
      }
      default:
        return date;
    }
  } else {
    switch (dir) {
      case 'Prev':
        return date.set({
          start: date.start.minus({ [ofOption]: 1 }).startOf(ofOption),
          end: date.end.minus({ [ofOption]: 1 }).endOf(ofOption),
        });
      case 'Next':
        return date.set({
          start: date.start.plus({ [ofOption]: 1 }).startOf(ofOption),
          end: date.end.plus({ [ofOption]: 1 }).endOf(ofOption),
        });
      default: {
        return date;
      }
    }
  }
}

export function getCurrentDate(mode: DatePickerMode) {
  const ofOption = mode.toLowerCase();
  if (mode === 'Week') {
    return Interval.fromDateTimes(
      DateTime.local().startOf(ofOption).minus({ days: 1 }),
      DateTime.local().endOf(ofOption).minus({ days: 1 }),
    );
  }
  return Interval.fromDateTimes(
    DateTime.local().startOf(ofOption),
    DateTime.local().endOf(ofOption),
  );
}
